export default __webpack_public_path__ + "static/media/Minimize.17a1210f.svg";